import { Button } from '@/components/ui/button';
import { useSignupModal } from '@/zustand/store';
import { useUserInfo } from '@/provider/UserInfoProvider';
import { posthogUTM, RPostHog } from '@/posthog';
import { useDeviceType } from '@/ueshook/useDeviceType';
import { Check } from 'phosphor-react';

interface FreePlanCardProps {}

const { utm } = posthogUTM();
export function FreePlanCard({}: FreePlanCardProps) {
  const deviceType = useDeviceType();
  const setSignupModalOpen = useSignupModal((s) => s.setSignupModalOpen);
  const { userIdentity } = useUserInfo();

  const handleGetStarted = () => {
    RPostHog('login_after_click_free_btn', {
      user_identity: userIdentity,
      ...utm,
    });

    setSignupModalOpen(true);
  };

  return (
    <div className={`rounded-xl border border-gray-200 p-6`}>
      <div className='flex flex-row items-center justify-start gap-4'>
        <h3 className='text-xl font-semibold text-[#252933]'>Free HD Images</h3>
      </div>

      <div className='mt-4 flex flex-row items-center justify-between'>
        <div className='flex items-baseline'>
          <span className='text-3xl font-bold text-[#252933]'>$0</span>
        </div>
      </div>

      <Button
        className={`${deviceType === 'mobile' ? 'mt-4' : 'mt-14'} w-full border border-gray-200 bg-white px-4 text-gray-900 hover:bg-gray-50`}
        onClick={handleGetStarted}
      >
        Get started
      </Button>

      <div className='mt-6 space-y-3'>
        {[
          'Download HD Images',
          'Edit history access',
          'Priority Processing Speed',
        ].map((feature, index) => (
          <div key={index} className='flex items-center gap-2'>
            <Check size={20} weight='bold' className='text-[#6137E0]' />
            <span className='text-[16px] text-[#252933]'>{feature}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
